import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const FlexibleDatesImage = () => {
  const data = useStaticQuery(graphql`
    query {
      FlexibleDatesImage: file(
        relativePath: { eq: "platform/offers/flexible-dates.png" }
      ) {
        childImageSharp {
          fluid(maxWidth: 1000) {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `)

  return (
    <Img
      fluid={data.FlexibleDatesImage.childImageSharp.fluid}
      alt="Offer Header Image"
    />
  )
}

export default FlexibleDatesImage
